/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/radio/custom-elements';

import { defineCustomElement as defineOsdsRadio } from '@ovhcloud/ods-stencil/components/radio/custom-elements/osds-radio.js';
import { defineCustomElement as defineOsdsRadioGroup } from '@ovhcloud/ods-stencil/components/radio/custom-elements/osds-radio-group.js';

export const OsdsRadio = /*@__PURE__*/createReactComponent<JSX.OsdsRadio, HTMLOsdsRadioElement>('osds-radio', undefined, undefined, defineOsdsRadio);
export const OsdsRadioGroup = /*@__PURE__*/createReactComponent<JSX.OsdsRadioGroup, HTMLOsdsRadioGroupElement>('osds-radio-group', undefined, undefined, defineOsdsRadioGroup);
